export default "__VITE_ASSET__5210b528__"